module.exports = __webpack_public_path__ + "img/kl_kdqb.8fc974f0.png";